import { Component, createRef } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import IconClock from "../../../../common/components/icons/IconClock";
import IconChevronDown from "../../../../common/components/icons/IconChevronDown";
import IconChevronUp from "../../../../common/components/icons/IconChevronUp";
import { GTM_ID, GA4EVENT, TIME_FORMAT_OPTIONS } from "../../../constants";
import actions from "../../../actions";
import FormattedDate from "../../../../common/components/FormattedDate";
import DetailModal from "../../modal/DetailModal";
import { isMobileOnly } from "react-device-detect";

class TimezonePicker extends Component {
    container = createRef();
    constructor(props) {
        super(props);

        this.renderTitle = this.renderTitle.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.renderDetail = this.renderDetail.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.togglePicker = this.togglePicker.bind(this);

        this.state = {
            openTimeZonePicker: false,
        };
    }

    onOptionSelected(option) {
        if (option.TimeZoneId === null) {
            var offsetValue = new Date().getTimezoneOffset();
            option = this.props.timezones.find((x) => x.OffsetValue === offsetValue);
        }

        this.props.onTimezoneChanged(option);

        this.togglePicker();
    }

    togglePicker() {
        if (this.state.openTimeZonePicker) {
            this.setState({ openTimeZonePicker: false });
            document.removeEventListener("click", this.handleOutsideClick, false);
        } else {
            this.setState({ openTimeZonePicker: true });
            document.addEventListener("click", this.handleOutsideClick, false);
        }
    }

    handleOutsideClick = (e) => {
        let currentPicker = this.container;
        if (currentPicker.current != null) {
            try {
                let timeZoneContainer = e.path?.indexOf(currentPicker.current) !== -1;
                if (!timeZoneContainer) {
                    this.togglePicker();
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    changeTimeFormat(timeFormat) {
        this.props.changeTimeFormat({ timeFormat });
        this.togglePicker();
    }

    renderTitle(isOpen) {
        if (!this.props.currentTime || !this.props.currentTimezone)
            return (
                <span>
                    <IconClock /> {this.props.translate("Loading")}
                </span>
            );

        return (
            <span>
                <IconClock />{" "}
                <FormattedDate
                    date={this.props.currentTime}
                    format={this.props.timeFormat === "ampm" ? "shortTime" : "HH:MM"}
                />{" "}
                <span>
                    {this.props.currentTimezone && this.props.hasDefautTimezones
                        ? `${this.props.translate("GMT")}${" "}${
                              this.props.currentTimezone.TimeSpan
                          }`
                        : this.props.currentTimezone.TimeSpan}{" "}
                </span>
                {isOpen ? <IconChevronUp /> : <IconChevronDown />}
            </span>
        );
    }

    renderOption(option) {
        return (
            <span>
                {option.TimeZoneId && (
                    <span>
                        <span>
                            (
                            {this.props.hasDefautTimezones
                                ? this.props.translate("GMT") + option.TimeSpan
                                : option.TimeSpan}
                            ){" "}
                        </span>
                        <span>{"    "}</span>
                        <span class="fxs_c_timezone-id">{option.TimeZoneId}</span>
                    </span>
                )}
            </span>
        );
    }

    renderDetail(config, timezones, timeFormat, automaticallyTimeZone, isMobileOnly) {
        return (
            <div class="fxs_c_timezone-container">
                <div class="fxs_c_timezone_header">
                    {isMobileOnly ? (
                        <h3 class="fxs_headline_small">
                            {this.props.translate("TimeZone_TimeFormat")}
                        </h3>
                    ) : (
                        <span>{this.props.translate("TimeZone_TimeFormat")}</span>
                    )}
                    {isMobileOnly ? (
                        <form>
                            <div>
                                <input
                                    type="radio"
                                    name="timeFormat"
                                    onClick={() =>
                                        this.changeTimeFormat(
                                            TIME_FORMAT_OPTIONS.TwentyFourHours
                                        )
                                    }
                                    checked={
                                        timeFormat === TIME_FORMAT_OPTIONS.TwentyFourHours
                                    }
                                    id={TIME_FORMAT_OPTIONS.TwentyFourHours}
                                    data-gtmid={
                                        config.tracking &&
                                        GTM_ID.TIMEZONE_DROPDOWN_OPTION("notampm")
                                    }
                                    data-ga4event-clk-name={
                                        config.tracking &&
                                        GA4EVENT.NAMES.FEATURES_CALENDAR
                                    }
                                    data-ga4event-element={
                                        config.tracking &&
                                        GA4EVENT.ELEMENTS.TIMEZONE_DROPDOWN_OPTION
                                    }
                                    data-ga4event-timezone={config.tracking && "notampm"}
                                />
                                <label for={TIME_FORMAT_OPTIONS.TwentyFourHours}>
                                    24h
                                </label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    name="timeFormat"
                                    onClick={() =>
                                        this.changeTimeFormat(
                                            TIME_FORMAT_OPTIONS.TwelveHours
                                        )
                                    }
                                    checked={
                                        timeFormat === TIME_FORMAT_OPTIONS.TwelveHours
                                    }
                                    id={TIME_FORMAT_OPTIONS.TwelveHours}
                                    data-gtmid={
                                        config.tracking &&
                                        GTM_ID.TIMEZONE_DROPDOWN_OPTION("ampm")
                                    }
                                    data-ga4event-clk-name={
                                        config.tracking &&
                                        GA4EVENT.NAMES.FEATURES_CALENDAR
                                    }
                                    data-ga4event-element={
                                        config.tracking &&
                                        GA4EVENT.ELEMENTS.TIMEZONE_DROPDOWN_OPTION
                                    }
                                    data-ga4event-timezone={config.tracking && "ampm"}
                                />
                                <label for={TIME_FORMAT_OPTIONS.TwelveHours}>AM/PM</label>
                            </div>
                        </form>
                    ) : (
                        <form>
                            <input
                                type="radio"
                                name="timeFormat"
                                data-gtmid={
                                    config.tracking && GTM_ID.TIMEZONE_TIMEFORMAT_24H
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.TIMEZONE_TIMEFORMAT_24H
                                }
                                onClick={() =>
                                    this.changeTimeFormat(
                                        TIME_FORMAT_OPTIONS.TwentyFourHours
                                    )
                                }
                                checked={
                                    timeFormat === TIME_FORMAT_OPTIONS.TwentyFourHours
                                }
                                id={TIME_FORMAT_OPTIONS.TwentyFourHours}
                            />
                            <label for={TIME_FORMAT_OPTIONS.TwentyFourHours}>24h</label>

                            <input
                                type="radio"
                                name="timeFormat"
                                data-gtmid={
                                    config.tracking && GTM_ID.TIMEZONE_TIMEFORMAT_AMPM
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.TIMEZONE_TIMEFORMAT_AMPM
                                }
                                onClick={() =>
                                    this.changeTimeFormat(TIME_FORMAT_OPTIONS.TwelveHours)
                                }
                                checked={timeFormat === TIME_FORMAT_OPTIONS.TwelveHours}
                                id={TIME_FORMAT_OPTIONS.TwelveHours}
                            />
                            <label for={TIME_FORMAT_OPTIONS.TwelveHours}>AM/PM</label>
                        </form>
                    )}
                </div>
                <hr class="fxs_c_datePicker_button_divider" />
                <dl>
                    {timezones
                        .filter((timezone) => timezone.TimeZoneId !== null)
                        .map((timezone) => (
                            <dt
                                data-gtmid={
                                    config.tracking &&
                                    GTM_ID.TIMEZONE_DROPDOWN_OPTION(
                                        "configgtm" + timezone.TimeSpan.replace("GMT", "")
                                    )
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking &&
                                    GA4EVENT.ELEMENTS.TIMEZONE_DROPDOWN_OPTION
                                }
                                data-ga4event-timezone={
                                    config.tracking &&
                                    timezone.TimeSpan.replace("GMT", "")
                                }
                                onClick={() => this.onOptionSelected(timezone)}
                            >
                                {this.renderOption(timezone)}
                            </dt>
                        ))}
                </dl>
                <button
                    type="button"
                    onClick={() => this.onOptionSelected(automaticallyTimeZone)}
                    data-gtmid={
                        config.tracking &&
                        GTM_ID.TIMEZONE_DROPDOWN_OPTION("setautomatically")
                    }
                    data-ga4event-clk-name={
                        config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                    data-ga4event-element={
                        config.tracking && GA4EVENT.ELEMENTS.TIMEZONE_DROPDOWN_OPTION
                    }
                    data-ga4event-timezone={config.tracking && "setautomatically"}
                    class="fxs_btn fxs_btn_anchor fxs_fRight"
                >
                    <span>{automaticallyTimeZone && automaticallyTimeZone.TimeSpan}</span>
                </button>
            </div>
        );
    }

    render({
        currentTimezone,
        buttonSizeClass = "fxs_btn_xsmall",
        containerClass = "",
        config,
        settings,
        timezones,
        timeFormat,
        automaticallyTimeZone,
    }) {
        return isMobileOnly ? (
            <div class="fxs_c_timezone-wrapper" ref={this.container}>
                <button
                    type="button"
                    data-gtmid={config.tracking && GTM_ID.TIMEZONE_DROPDOWN}
                    data-ga4event-clk-name={
                        config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                    data-ga4event-element={
                        config.tracking && GA4EVENT.ELEMENTS.TIMEZONE_DROPDOWN
                    }
                    onClick={this.togglePicker}
                    class="fxs_btn fxs_btn_xsmall fxs_btn_phantom"
                >
                    {this.renderTitle(this.state.openTimeZonePicker)}
                </button>
                {this.state.openTimeZonePicker && (
                    <DetailModal
                        handleClose={this.togglePicker}
                        body={this.renderDetail(
                            config,
                            timezones,
                            timeFormat,
                            automaticallyTimeZone,
                            isMobileOnly
                        )}
                    />
                )}
            </div>
        ) : (
            <div class="fxs_c_timezone-wrapper" ref={this.container}>
                <button
                    type="button"
                    data-gtmid={config.tracking && GTM_ID.TIMEZONE_DROPDOWN}
                    data-ga4event-clk-name={
                        config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                    data-ga4event-element={
                        config.tracking && GA4EVENT.ELEMENTS.TIMEZONE_DROPDOWN
                    }
                    onClick={this.togglePicker}
                    class="fxs_btn fxs_btn_xsmall fxs_btn_phantom"
                >
                    {this.renderTitle(this.state.openTimeZonePicker)}
                </button>
                {this.state.openTimeZonePicker &&
                    this.renderDetail(
                        config,
                        timezones,
                        timeFormat,
                        automaticallyTimeZone,
                        isMobileOnly
                    )}
            </div>
        );
    }
}

export default connectWithTranslations(
    "config, timezones, settings, timeFormat, currentTime, automaticallyTimeZone, currentTimezone, hasDefautTimezones",
    actions
)(TimezonePicker);
